export const ORDER_STATES = [
    'pending',
    'succeeded',
    'failed',
    'expired',
    'refunded',
];
export const ORDER_STATE_LABEL = {
    pending: 'Ожидает',
    succeeded: 'Оплачен',
    failed: 'Ошибка',
    expired: 'Истёк',
    refunded: 'Возврат',
};
